module.exports = __webpack_public_path__ + "ba3e909e98a4c58c6a15f043f2e1a8a7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!../data/badlogic.jpg
 ** module id = 63
 ** module chunks = 0
 **/